const MICROS_PER_DOLLAR = 1_000_000

// Cost is a non-production affordance only. Pricing lives server-side —
// daystrom computes cost_micros per step and lukita stamps it per message;
// this only formats what they hand back.
export function formatCostMicros(micros: number): string {
  if (!Number.isFinite(micros) || micros <= 0) return '$0'
  const dollars = micros / MICROS_PER_DOLLAR
  if (dollars < 0.001) return '<$0.001'
  if (dollars < 1) return `$${dollars.toFixed(4)}`
  if (dollars < 100) return `$${dollars.toFixed(3)}`
  return `$${dollars.toFixed(2)}`
}
